import { OOB } from './index';
import { Action } from '../action';

export class OobInitAction implements Action {
	readonly type = OOB.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class OobDestroyAction implements Action {
	readonly type = OOB.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class OobClickLoginAction implements Action {
	readonly type = OOB.CLICK_LOGIN;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
